module.exports = "images/get-inspired-10.webp";